module.exports = __webpack_public_path__ + "img/0-lg.0f9d20fa.jpg";